import useBatchStore from "./use-batch-store";
import { useBatchPollingWithTanStack } from "@adora/shared/features/batches/use-batch-polling";

const useBatchPolling = () => {
  const { batches: batchesFromStore, updateBatch } = useBatchStore();
  useBatchPollingWithTanStack(batchesFromStore, updateBatch);
};

export default useBatchPolling;
